import './assets/styles/App.css'
import Gallery from './pages/Gallery'
import About from './pages/About'
import Home from './pages/Home'
import Wishlist from './pages/Wishlist'
import Process from './pages/Process'
import Contact from './pages/Contact'
import { Routes, Route } from 'react-router-dom'
import { WishlistProvider } from './context/WishlistContext'
import { FilterProvider } from './context/FilterContext'
import Landing from './pages/Landing';

const App = () => {
  return (
    <WishlistProvider>
      <FilterProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/process" element={<Process />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/landing" element={<Landing />} />
        </Routes>
      </FilterProvider>
    </WishlistProvider>
  )
}

export default App